import React from 'react';
import Copy from '../../../assets/Copy';
import MailDone from '../../../assets/MailDone';
import s from './MailSent.module.scss';
export const MailSent = ({ ...parameters }: any) => {
  return (
    <div className={s.wrapper}>
      <div className={s.svg}>
        <MailDone />
      </div>
      <div className={s.title}>Email Sent to you</div>
    </div>
  );
};
